import { render } from "./shortMessage.vue?vue&type=template&id=03e9ab96&scoped=true"
import script from "./shortMessage.vue?vue&type=script&lang=js"
export * from "./shortMessage.vue?vue&type=script&lang=js"

import "./shortMessage.vue?vue&type=style&index=0&id=03e9ab96&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e9ab96"]])

export default __exports__